/*
 * @Author: limin
 * @Date: 2019-08-26 18:02:55
 * @Last Modified by: chenwq
 * @Last Modified time: 2021-06-07 16:30:53
 */

import request from "./request"
import RequestMethods from "./request.methods"

export const BASE_DATA_URL = "fims.configuration.from.conftype"

const path = "dj.api."

// 获取商品分类列表
export function getProductType(data) {
  data.method = `${path}goods.type.list`
  return request(data)
}
// 获取不同场景的商品分类
export function getGoodsCategoryConfiguration(data) {
  data.currentPage = 1
  data.pageSize = 999999
  // data.method = `${path}goodsCategoryConfiguration.page`
  data.method = `${path}goodsCategoryConfiguration.page.new`
  return request(data)
}

// 获取渠道列表
export function getChannelType(data) {
  data.method = `${path}channel.type.list`
  return request(data)
}

// 图片上传
export function uploadImg(data) {
  data.method = `${path}common.uploadImg`
  return request(data, RequestMethods.POST, ["file"])
}

// 图片识别
export function imgRecognitionApi(data) {
  data.method = `${path}common.ocr.recognition`
  return request(data, RequestMethods.POST)
}

// 银行列表
export function getBankListApi(data) {
  data.method = `${path}yseBankInfo.bankList`
  return request(data, RequestMethods.POST)
}

// 银行列表-支行
export function getYseBankListApi(data) {
  data.method = `${path}yseBankInfo.listWithPage`
  return request(data, RequestMethods.POST)
}

// 给指定号码发送验证码
export function sendToSmsCodeApi(data) {
  data.method = `${path}smartcarlife.sms.sendSmsCode`
  return request(data, RequestMethods.POST)
}

// 获取配置列表
export function commonConfigApi(data) {
  data.method = `${path}common.config.list`
  return request(data, RequestMethods.POST)
}

// Excel异步导出
export function asyncExportExcel(data) {
  data.method = `${path}common.async.exportExcel`
  return request(data, RequestMethods.POST)
}

// 获取Excel异步导出查询导出结果
export function exportExcel(data) {
  data.method = `${path}common.query.async.exportExcel`
  return request(data, RequestMethods.POST)
}

// 视频上传
export function uploadVideo(data) {
  data.method = `${path}smartcarlife.common.uploadVideo`
  return request(data, RequestMethods.POST, ["file"])
}

// 类目列表获取
export function queryFeeCategoryByType(data) {
  // data.method = `${path}smartcarlife.feeCategory.queryFeeCategoryByType`
  data.method = `${path}smartcarlife.feeCategory.page`
  return request(data, RequestMethods.POST)
}

// pdf上传
export function uploadPDF(data) {
  data.method = `${path}smartcarlife.common.uploadPdf`
  return request(data, RequestMethods.POST, ["file"])
}

// 获取太阳膜类商品部位属性
export function getPositionList(data) {
  data.method = `${path}smartcarlife.goodsPosition.list`
  return request(data)
}

// excel上传
export function uploadExcel(data) {
  data.method = `${path}smartcarlife.common.uploadExcel`
  return request(data, RequestMethods.POST, ["file"])
}

// 文件上传通用接口
// fileType 文件类型(image,video,pdf,excel,doc)
export function uploadFile(data) {
  data.method = `${path}common.uploadFile`
  return request(data, RequestMethods.POST, ["file"])
}
